// Wspólny zestaw sortowania dla list publikacji — te same opcje, kolejność i nazwy wszędzie.
export const SORT_OPTION_TITLE_ASC = { value: 'title-asc', label: 'A-Z', labelKey: 'T_SORT_A_Z' }
export const SORT_OPTION_TITLE_DESC = { value: 'title-desc', label: 'Z-A', labelKey: 'T_SORT_Z_A' }
export const SORT_OPTION_NEWEST = { value: 'newest', label: 'Od najnowszych', labelKey: 'T_SORT_FROM_NEWEST' }
export const SORT_OPTION_OLDEST = { value: 'oldest', label: 'Od najstarszych', labelKey: 'T_SORT_FROM_OLDEST' }

export const LIST_SORT_OPTIONS = [SORT_OPTION_TITLE_ASC, SORT_OPTION_TITLE_DESC, SORT_OPTION_NEWEST, SORT_OPTION_OLDEST]

// Parametry `orderBy`/`order` dla endpointów wyszukiwania Doctrine (książki, czasopisma).
export const getListSortParams = (sortValue) => {
  switch (sortValue) {
    case 'newest':
      return { orderBy: 'publishedAt', order: 'desc' }
    case 'oldest':
      return { orderBy: 'publishedAt', order: 'asc' }
    case 'title-desc':
      return { orderBy: 'title', order: 'desc' }
    default:
      return { orderBy: 'title', order: 'asc' }
  }
}
